<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-warehouse"></em></span
    >{{ "RegistrationFormSearch.Header" | translate }}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab
        header="{{ 'Common.Form.Header' | translate }}"
        [selected]="isSearchFormOpen"
      >
        <form [formGroup]="searchForm">
          <div class="block">
            <div class="p-fluid grid">
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{
                    "RegistrationFormSearch.Search.Registrationkey" | translate
                  }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="registrationKey"
                    separator=","
                    [(ngModel)]="searchParams.registrationKey"
                    (onAdd)="chipsAdd($event, 'registrationKey')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "Purchase.Search.Facility" | translate }}
                </div>
                <div class="block">
                  <laas-facility-dropdown
                    formControlName="facility"
                    [isMultiple]="true"
                    [showClear]="false"
                    [showFilter]="true"
                    [showToggleAll]="true"
                    [defaultSelectFirst]="true"
                    (onOptionDataChange)="optionsDataOnChange($event, 'facility')"
                  >
                  </laas-facility-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "RegistrationForm.Create.ReferenceType" | translate }}
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="referenceType"
                    [(ngModel)]="searchParams.referenceType"
                    [options]="referenceTypeOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    (onClick)="selectReferenceType()"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "RegistrationFormSearch.Search.Referencekey" | translate }}
                </div>
                <div class="block">
                  <p-chips
                    formControlName="referenceKey"
                    separator=","
                    [(ngModel)]="searchParams.referenceKey"
                    (onAdd)="chipsAdd($event, 'referenceKey')"
                  ></p-chips>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "RegistrationFormSearch.Search.Forwarder" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="forwarder"
                    [(ngModel)]="searchParams.forwarder"
                    [options]="forwarderOptions"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                    filterBy="label"
                  >
                  </p-multiSelect>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  <label>{{
                    "RegistrationFormSearch.Search.IsArrived" | translate
                  }}</label>
                </div>
                <div class="block">
                  <p-dropdown
                    formControlName="isArrived"
                    optionLabel="label"
                    optionValue="value"
                    [(ngModel)]="searchParams.isArrived"
                    [options]="isArrivedOptions"
                    styleClass="p-text-left"
                    [showClear]="true"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                  ></p-dropdown>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 laas-calendar">
                <laas-calendar
                  #createDt
                  [title]="'RegistrationFormSearch.Search.CreateDt'"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event, 'createDt')"
                >
                </laas-calendar>
              </div>
              <div class="col-12 md:col-6 lg:col-3 mb-3">
                <div class="block mb-1">
                  {{ "RegistrationFormSearch.Search.Abnormal" | translate }}
                </div>
                <div class="block">
                  <p-multiSelect
                    formControlName="abnormalReference"
                    [(ngModel)]="searchParams.abnormalReference"
                    [options]="abnormalOptions"
                    placeholder="{{
                      'Common.Message.ChooseOption' | translate
                    }}"
                    [filter]="true"
                    filterBy="label"
                  >
                  </p-multiSelect>
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="inline-block mb-1">
              <button
                pButton
                type="button"
                (click)="searchBtnClick()"
                label="{{ 'Common.Button.Search' | translate }}"
              ></button>
            </div>
            <div class="inline-block mb-1">
              <button
                pButton
                pRipple
                (click)="resetBtnClick($event)"
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-2"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        #headerTable
        [dataKey]="'registrationKey'"
        [defaultColumns]="columns"
        [loading]="isLoading"
        [value]="searchResults"
        [selectable]="true"
        [(selectedRows)]="selectedRows"
        [editPermission]="editPermissionCode"
        [isShowCreateRowFunction]="false"
        [inputValid]="dataInputValid"
        (savedData)="saveData($event)"
      >
        <ng-template pTemplate="caption">
          <div class="inline-block my-1">
            <button
              pButton
              pRipple
              [disabled]="selectedRows.length == 0"
              (click)="comfirmArrived($event)"
              class="p-button-success ml-4"
              label="{{
                'RegistrationFormSearch.Button.ComfirmArrived' | translate
              }}"
            ></button>
          </div>
          <div class="inline-block my-1">
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Export' | translate }}"
              (click)="downloadExcelBtn($event)"
              class="ml-4"
            ></button>
          </div>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'orgId'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : orgOptions }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'forwarderCode'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : forwarderOptions }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'abnormalReference'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | optionsMapping : abnormalOptions
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'edc'" class="p-fluid">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss"
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss"
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'updateDt'">
                <div class="overflow-text">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss"
                      | replaceNullWith : "-"
                  }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType" class="overflow-text">
                  <ng-container *ngSwitchCase="'date'">
                    {{
                      rowData[col.field]
                        | date : "yyyy-MM-dd HH:mm:ss"
                        | replaceNullWith : "-"
                    }}
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ rowData[col.field] | replaceNullWith : "-" }}
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
        <!--Input-->
        <ng-template pTemplate="bodyInputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'forwarderCode'" class="p-fluid">
              <ng-container *ngIf="editForwarder">
                <p-dropdown
                  appendTo="body"
                  class="p-fluid"
                  [(ngModel)]="rowData[col.field]"
                  [options]="forwarderOptions"
                  [filter]="true"
                  filterBy="label"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                >
                </p-dropdown>
                <small *ngIf="!rowData[col.field]" class="alert">
                  <div class="p-invalid">
                    {{ "Common.Button.Required" | translate }}
                  </div>
                </small>
              </ng-container>
              <ng-container *ngIf="!editForwarder">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping : forwarderOptions }}
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'vendorName'" class="p-fluid">
              <p-autoComplete
                appendTo="body"
                class="p-fluid"
                [(ngModel)]="rowData[col.field]"
                [suggestions]="vendorSuggests"
                (completeMethod)="getVendorOptions($event)"
              >
              </p-autoComplete>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ "Common.Button.Required" | translate }}
                </div>
              </small>
            </ng-container>
            <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
              <p-dropdown
                appendTo="body"
                class="p-fluid"
                [(ngModel)]="rowData[col.field]"
                [options]="orgOptions"
                [filter]="true"
                filterBy="label"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              >
              </p-dropdown>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ "Common.Button.Required" | translate }}
                </div>
              </small>
            </ng-container>
            <ng-container *ngSwitchCase="'totalCtn'" class="p-fluid">
              <input
                type="text"
                pInputText
                [(ngModel)]="rowData[col.field]"
                appendTo="body"
                class="p-fluid"
              />
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ "Common.Button.Required" | translate }}
                </div>
              </small>
            </ng-container>
            <ng-container *ngSwitchCase="'referenceType'" class="p-fluid">
              <p-dropdown
                appendTo="body"
                class="p-fluid"
                [(ngModel)]="rowData[col.field]"
                [options]="referenceTypeOptions"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              >
              </p-dropdown>
              <small *ngIf="!rowData[col.field]" class="alert">
                <div class="p-invalid">
                  {{ "Common.Button.Required" | translate }}
                </div>
              </small>
            </ng-container>
            <ng-container *ngSwitchCase="'referenceKey'">
              <input
                type="text"
                pInputText
                [(ngModel)]="rowData[col.field]"
                appendTo="body"
                class="p-fluid"
              />
              <small *ngIf="!rowData[col.field]" class="alert" class="p-fluid">
                <div class="p-invalid">
                  {{ "Common.Button.Required" | translate }}
                </div>
              </small>
            </ng-container>
            <ng-container *ngSwitchCase="'edc'" class="p-fluid">
              <p-calendar
                appendTo="body"
                dateFormat="yy-mm-dd"
                [showTime]="true"
                [(ngModel)]="rowData[col.field]"
              >
              </p-calendar>
            </ng-container>
            <ng-container *ngSwitchCase="'palletCnt'" class="p-fluid">
              <input
                type="text"
                pInputText
                [(ngModel)]="rowData[col.field]"
                appendTo="body"
                class="p-fluid"
              />
            </ng-container>
            <ng-container *ngSwitchCase="'isArrived'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'abnormalReference'" class="p-fluid">
              <p-multiSelect
                appendTo="body"
                class="p-fluid"
                [(ngModel)]="rowData[col.field]"
                [options]="abnormalOptions"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'" class="p-fluid">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd HH:mm:ss"
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'" class="p-fluid">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd HH:mm:ss"
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateUser'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType" class="overflow-text">
                <ng-container *ngSwitchCase="'date'" class="p-fluid">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss"
                      | replaceNullWith : "-"
                  }}
                </ng-container>
                <ng-container *ngSwitchDefault class="p-fluid">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
        <!--Output-->
        <ng-template pTemplate="bodyOutputTemplate" let-rowData let-col="col">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'orgId'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : orgOptions }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'forwarderCode'" class="p-fluid">
              <div class="overflow-text">
                {{ rowData[col.field] | optionsMapping : forwarderOptions }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'abnormalReference'">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | optionsMapping : abnormalOptions
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'edc'" class="p-fluid">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd HH:mm:ss"
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'createDt'" class="p-fluid">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd HH:mm:ss"
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'updateDt'" class="p-fluid">
              <div class="overflow-text">
                {{
                  rowData[col.field]
                    | date : "yyyy-MM-dd HH:mm:ss"
                    | replaceNullWith : "-"
                }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType" class="overflow-text">
                <ng-container *ngSwitchCase="'date'" class="p-fluid">
                  {{
                    rowData[col.field]
                      | date : "yyyy-MM-dd HH:mm:ss"
                      | replaceNullWith : "-"
                  }}
                </ng-container>
                <ng-container *ngSwitchDefault class="p-fluid">
                  {{ rowData[col.field] | replaceNullWith : "-" }}
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
